import { render, staticRenderFns } from "./kqgb.vue?vue&type=template&id=3daf0721&scoped=true&"
import script from "./kqgb.vue?vue&type=script&lang=js&"
export * from "./kqgb.vue?vue&type=script&lang=js&"
import style0 from "./kqgb.vue?vue&type=style&index=0&id=3daf0721&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daf0721",
  null
  
)

export default component.exports